module.exports = __webpack_public_path__ + "img/Porto Apartment - 7 of 85.9ec83470.jpeg";